import React from 'react';

export const SearchItemLoading = () => {
    return (
        <li className="list-group-item">
            <div className="row">
                <div className="col-md-1 col-lg-1">
                    <p className="text-center text-secondary mt-3 mt-md-0">
                        <svg
                            className="bd-placeholder-img"
                            width="45"
                            height="45"
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-label="Placeholder"
                            preserveAspectRatio="xMidYMid slice"
                            focusable="false">
                            <title>Placeholder</title>
                            <rect width="100%" height="100%" fill="#C4C8CB"></rect>
                        </svg>
                    </p>
                </div>
                <div className="placeholder-glow col-md-3 col-lg-5">
                    <span className="placeholder w-100 mt-1 mb-3"></span>
                </div>
                <div className="placeholder-glow col-md-4 col-lg-3">
                    <span className="placeholder w-100 mt-1 mb-3"></span>
                </div>
                <div className="col-md-4 col-lg-3">
                    <div className="d-grid">
                        <span className="btn btn-primary disabled placeholder mb-3"></span>
                    </div>
                </div>
            </div>
        </li>
    );
};
